(() => {
  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

  const randomInteger = (minimum, maximum) => {
    const low = Math.min(minimum, maximum);
    const high = Math.max(minimum, maximum);
    return Math.floor(Math.random() * (high - low + 1)) + low;
  };

  document.querySelectorAll('[data-velaris-live-proof]').forEach((component) => {
    if (component.dataset.initialized === 'true') return;
    component.dataset.initialized = 'true';

    const viewersElement = component.querySelector('[data-velaris-viewers]');
    const salesElement = component.querySelector('[data-velaris-sales]');
    const settings = {
      viewersMinimum: Number(component.dataset.viewersMinimum),
      viewersMaximum: Number(component.dataset.viewersMaximum),
      viewerIntervalMinimum: Number(component.dataset.viewerIntervalMinimum) * 1000,
      viewerIntervalMaximum: Number(component.dataset.viewerIntervalMaximum) * 1000,
      salesPeriodHours: Number(component.dataset.salesPeriodHours),
      salesMinimum: Number(component.dataset.salesMinimum),
      salesTargetMinimum: Number(component.dataset.salesTargetMinimum),
      salesTargetMaximum: Number(component.dataset.salesTargetMaximum),
      salesRefreshInterval: Number(component.dataset.salesRefreshInterval) * 1000,
    };

    const updateViewers = () => {
      if (!viewersElement) return;

      const current = Number(viewersElement.textContent);
      let next = randomInteger(settings.viewersMinimum, settings.viewersMaximum);

      if (settings.viewersMinimum !== settings.viewersMaximum) {
        while (next === current) next = randomInteger(settings.viewersMinimum, settings.viewersMaximum);
      }

      viewersElement.textContent = next;
      window.setTimeout(updateViewers, randomInteger(settings.viewerIntervalMinimum, settings.viewerIntervalMaximum));
    };

    const updateSales = () => {
      if (!salesElement) return;

      const period = settings.salesPeriodHours * 60 * 60 * 1000;
      const periodNumber = Math.floor(Date.now() / period);
      const elapsed = Date.now() - periodNumber * period;
      const progress = clamp(elapsed / period, 0, 1);
      const targetRange = Math.max(settings.salesTargetMaximum - settings.salesTargetMinimum + 1, 1);
      const target = settings.salesTargetMinimum + ((periodNumber * 7 + 3) % targetRange);
      const sales = settings.salesMinimum + Math.floor((target - settings.salesMinimum) * progress);

      salesElement.textContent = clamp(sales, settings.salesMinimum, settings.salesTargetMaximum);
    };

    updateViewers();
    updateSales();
    window.setInterval(updateSales, settings.salesRefreshInterval);
  });
})();
